<mat-dialog-content style=" max-height: '200vh'; height: 100%;display: flex;flex-direction: column;">

  <ssrs-reportviewer
    [reportserver]="reportServer"
    [reporturl]="reportUrl"
    [showparameters]="showParameters"
    [parameters]="parameters"
    [language]="language"
    [width]="width"
    [height]="height"
    [toolbar]="toolbar"
    style="  flex-grow: 1;  height: 100%;">
  </ssrs-reportviewer>
    <button type="button" class="theme-button btn" style="width: 20%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="Exit_Dialog()" >{{ 'Exit' | translate }}</button>

</mat-dialog-content>

